export function show(companyId)
{
    return axios.get(route('api.manage.companies.billing-details.show', { company: companyId }))
        .then(result => result.data);
}

export function update(companyId, data)
{
    return axios.patch(route('api.manage.companies.billing-details.update', { company: companyId }), data)
        .then(result => result.data);
}

export function cancelMandate(companyId)
{
    return axios.delete(route('api.manage.companies.billing-details.cancel-mandate', { company: companyId }))
        .then(result => result.data);
}
